import { useQuery } from '@tanstack/react-query';
import { sickReports } from '@/utils/api';

export function useSickReports(params?: Record<string, any>) {
  return useQuery({
    queryKey: ['sick-reports', params],
    queryFn: () => sickReports.getAll(params).then((r) => r.data),
  });
}

export function useSickReportStats(params?: Record<string, any>) {
  return useQuery({
    queryKey: ['sick-reports', 'stats', params],
    queryFn: () => sickReports.getStats(params).then((r) => r.data),
  });
}
